<!-- <p>organisation-flagged-assets works!</p> -->
<!-- <p>user-favourites works!</p> -->

<div class="user-favourites">
    <span *ngIf="selectedOrganisation" style="font-size: large; font-weight: bolder;">{{ selectedOrganisation.Name }}
        Flagged Assets</span>
    <div class="middle-div alignRow">
        <span class="toolbar-spacer"></span>
        <mat-icon style="cursor: pointer;" *ngIf="selectedLocation"
            (click)="filterByLocation($event, true)">close</mat-icon>
        <div class="location-dropdown">
            <ejs-dropdownlist id="dropdown" #dropdown [dataSource]='MainLocations' placeholder="Select Location"
                [fields]="locationFields" (change)="filterByLocation($event)" [allowFiltering]="true"
                filterType="contains">
                <ng-template #itemTemplate let-data>
                    <div>
                        <span>{{ data.Name }}</span>
                    </div>
                </ng-template>
            </ejs-dropdownlist>
        </div>
    </div>
    <mat-form-field>
        <mat-label>Search for an Asset</mat-label>
        <input matInput (keyup)="onFiltering($event)" placeholder="" #input>
    </mat-form-field>
    <div class="favourite-item">
        <span></span>
        <span>Asset Name</span>
        <span>Added By</span>
        <span>Comment</span>
        <span>Flagged At</span>
    </div>
    <ejs-listbox *ngIf="FavouriteAssets && FavouriteAssets.length > 0" [dataSource]="FilteredFavouriteAssets"
        [fields]="fields" class="listbox">
        <ng-template #itemTemplate let-data>
            <div class="favourite-item">
                <img class="assetImage" src="{{imagePathAssets()}}{{data.AssetID}}?{{data.Modified}}"
                    style="max-height: 50px; max-width: 50px;"
                    onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
                    (click)='viewImage(imagePathAssets() + data.AssetID + "?" + data.Modified)'
                    [attr.x-contenttype]="'image/png'" />
                <span>{{data.Name}} - {{data.Description}}</span>
                <span>{{data.AddedByName}}</span>
                <span>{{data.Comment}}</span>
                <span>{{convertEpoch(data.AddedAt)}}</span>
                <button mat-raised-button color="primary" (click)="goToAsset(data)">
                    <span>Go To Asset</span>
                    <mat-icon>north_east</mat-icon>
                </button>
                <span (click)="removeFavourite(data)" class="app-icon app-icon--flagged alignColumn" matTooltip="Remove Flagged Asset">
                    <mat-icon/>
                </span>
            </div>
        </ng-template>
    </ejs-listbox>
</div>
